import request from '@/utils/request'

//获取回执单数据
export function GetReceiptList(params, config) {
  return request({
      url: `/api/other/qyg-official-receipt/order-receipt-info`,
      method: 'post',
      data: params,
      ...config
  })
}

//下载回执单
export function GetUpload(formData) {
  return request({
    url: `/api/other/upload/local-upload`,
    method: 'post',
    data: formData
  })
}
